<template>
    <div style="text-align: left">
     <el-button type="primary" style="width: 100%;
    height: 50px;
    font-size: 30px;" @click="openlink()" size="medium " icon="el-icon-link">打开链接</el-button>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// 用于自定义菜单节点
export default {
    name: `LayoutExtralPageNoFrame`,
    data() {
        return {
            title: `第三方页面`,
            refUrl: this.$route.query.source,
            token: this.$route.query.token,
            surgeryId: this.$route.query.surgery_id,
            layoutExtralPageNoFrameModel: this.$root.LayoutExtralPageNoFrameModel,
            surgeryInfo: {},
            from: this.$route.query.from,
            extralPageUrlMode: this.$root.ExtralPageUrlMode,
            checkCa: this.$route.query.checkCa,
            useCa: this.$root.useCa,
            visitInfo: {},
            hospitalward: {}
        }
    },
    mounted() {

    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.loadSurgery()
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        containerHeight() {
            return `${this.screenHeight - 120}px`
        }
    },
    methods: {
        isjson(jsonstr) {
            if (typeof jsonstr == `string`) {
                try {
                    var obj = JSON.parse(jsonstr)
                    if (typeof obj == `object` && obj) {
                        return true
                    } else {
                        return false
                    }
                } catch (e) {
                    return false
                }
            }
            return false
        },
        openlink() {
            let that = this
            if (that.refUrl.indexOf(`.exe`) > -1) {
                console.log(that.refUrl)
                let r = typeof winformMsg
                if (r != `undefined`) {
                    var cefJson = {
                        action: `openLink`,
                        refUrl: that.refUrl
                    }
                    winformMsg.acceptMessage(cefJson)
                } else {
                    this.$message.error(`请使用Desktop打开！`)
                }
            } else {
                window.open(this.refUrl)
            }
        },
        loadSurgery() {
            if (!this.surgeryId) {
                this.surgeryInfo = {}
                this.visitInfo = {}
                this.hospitalward = {}
                return
            }
            var that = this
            this.myaxios
                .get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                .then(data => {
                    let extrDatas = _.reduce(data.extra_datas, function(result, value, index) {
                        let flag = that.isjson(value.DataValue)
                        if (value.DataValue != `` && flag == true) {
                            result[value.DataKey] = value.DataExtraValue
                        } else {
                            result[value.DataKey] = value.DataValue
                        }
                        return result
                    }, {})
                    this.surgeryInfo = Object.assign(data, extrDatas)
                    this.visitInfo = data.visit_info
                    this.hospitalward = data.hospital_ward
                }).then(data => {
                    this.setRefurl()
                }).then(data => {
                    if (this.useCa == `1`) {
                        // 启用了ca后，判断是否验证ca账号
                        if (this.checkCa == `1`) {
                            // 如果验证账号，则跳转到ca系统进行ca认证
                            // let token = token.token
                            let catoken = sessionStorage.getItem(`caToken`)
                            let bodyurl = this.$root.CaLoginUrl.replace(`login`, `CheckCaUser`)
                            if (catoken) {
                                let sou = this.refUrl
                                let gotourl = `${bodyurl}?username=${this.currentUser.username}&checkCa=1&app_key=${this.$root.appKey}&redirect=${encodeURIComponent(sou)}`
                                this.refUrl = gotourl
                            }
                        }
                    }
                }).then(data => {
                    // ACIS-23927手麻系统集成360全息视图
                    if (this.refUrl.slice(0, 4) != `http` && this.refUrl.indexOf(`carte_`) != -1) {
                        let type = this.refUrl.split(`?`)[0]
                        let paramStr = this.refUrl.split(`?`)[1]
                        let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=${type}&paramStr=${paramStr}`)
                        req.then(data => {
                            this.refUrl = data
                            if (this.layoutExtralPageNoFrameModel == `0` && this.surgeryId && this.refUrl.indexOf(`@`) == -1) {
                                window.open(this.refUrl)
                            }
                        }).catch(e => {
                            console.log(e)
                        })
                    } else if (this.layoutExtralPageNoFrameModel == `0` && this.surgeryId && this.refUrl.indexOf(`@`) == -1) {
                        window.open(this.refUrl)
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        setRefurl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            if (this.from != `google`) {
                refUrl = decodeURIComponent(refUrl)
            }
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.visitInfo) {
                _.each(this.visitInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.surgeryInfo) {
                _.each(this.surgeryInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            console.log(this.surgeryInfo)

            if (this.hospitalward) {
                _.each(this.hospitalward, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.extralPageUrlMode == `1` && !_.includes(refUrl, `doccenter`)) {
                if (refUrl.indexOf(`?`) > -1) {
                    let refstr = refUrl.split(`?`)
                    refUrl = refstr[0] + `?` + encodeURIComponent(refUrl.replace(refstr[0] + `?`, ``))
                }
            }
            const newData = refUrl.replace(/{(.*?)}/g, (match, value) => {
                console.log(match, value)
                // refUrl.replace(match, value)
                return window.btoa(unescape(encodeURIComponent(value)))
            })
            this.refUrl = newData
            console.log(this.refUrl)
            return refUrl
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.refUrl = newUrl.query.source
            this.loadSurgery()
        }
    }
}
</script>

<style scoped>
.docframe {
    border: none;
    background: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutExtralPageNoFrame.vue